export enum EnquiryPropertyStatus {
  'new' = 'new',
  'open' = 'open',
  'contacted' = 'contacted',
  'booked' = 'booked',
  'let_agreed' = 'let_agreed',
  'closed' = 'closed',
}
